import React, { FC, useEffect, useRef } from 'react'
import Image from '@/base-components/image'

import styles from './index.module.less'
import { toOptions, redirectUrl } from '../../utils'

import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'

interface IItem {
  subTitle: string
  title: string
  imageUrl: string
  link: string
}
const Item: FC<IItem> = ({ subTitle, title, imageUrl, link }) => {
  return (
    <>
      <div
        className={styles.pageCon}
        onClick={() => {
          console.info('Item link', link)
          redirectUrl(link)
        }}
      >
        <div className={styles.info}>
          <p className={styles.title}>{title}</p>
          {subTitle ? <p className={styles.subTitle}>{subTitle}</p> : null}
        </div>
        <div className={styles.imgCon}>
          <Image src={imageUrl} className={styles.img} options={toOptions(174, 174)} />
        </div>
      </div>
    </>
  )
}

interface IContent {
  activeTab: number
  setActiveTab: (T: number) => void
  tabPageLists: IItem[][]
}
const Content: FC<IContent> = ({ activeTab, setActiveTab, tabPageLists }) => {
  const swiperRef = useRef<any>(null)
  const onSlideChange = (e: any) => {
    setActiveTab(e.realIndex)
  }

  useEffect(() => {
    swiperRef.current?.swiper?.slideTo(activeTab)
  }, [activeTab])

  return (
    <div className={styles.contentWrap}>
      <div className={styles.contentList}>
        <Swiper onSlideChange={onSlideChange} ref={swiperRef}>
          {tabPageLists.map((tabPageList, index) => (
            <SwiperSlide key={index}>
              {tabPageList.map((item, i) => {
                return <Item key={i} {...item} />
              })}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default Content
